import React, { type ReactElement } from 'react';
import classNames from 'classnames';
import Text from '@/common/components/text/text.component';
import SpinnerIcon from '~/public/assets/images/svg/loader-spinner-icon.svg';

interface Props {
  className?: string;
}

function Loading({ className }: Props): ReactElement {
  return (
    <div
      className={classNames(
        'fixed bottom-0 right-0 z-[100] flex h-full w-full flex-col items-center justify-center gap-4 bg-white/80',
        { className }
      )}
    >
      <SpinnerIcon className={`h-7 w-7 animate-spin text-secondary-400`} />
      <Text className=" block text-base font-medium text-secondary-400">
        چند لحظه صبر کنید
      </Text>
    </div>
  );
}

export default Loading;
